import { render, staticRenderFns } from "./MenuGroup.vue?vue&type=template&id=ccfafbd4&scoped=true"
import script from "./MenuGroup.vue?vue&type=script&lang=js"
export * from "./MenuGroup.vue?vue&type=script&lang=js"
import style0 from "./MenuGroup.vue?vue&type=style&index=0&id=ccfafbd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfafbd4",
  null
  
)

export default component.exports